<script setup>
import { PopoverTrigger } from 'reka-ui';

const props = defineProps({
	asChild: { type: Boolean, required: false },
	as: { type: null, required: false },
});
</script>

<template>
	<PopoverTrigger
		data-slot="popover-trigger"
		v-bind="props"
	>
		<slot />
	</PopoverTrigger>
</template>
